import React, { Component } from "react";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print, Info } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchItemMaster, fetchTaxMaster } from "./API";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import {
  loadValuesIntoMainArray,
  copyArrayValue,
  applyTrimOnArray,
  getRowsWithColsExists,
  applyTrimOnObjectValues,
  setKeyboardShortcuts,
  csvFileName,
  getRowOfRT,
} from "../SystemUtility/SystemUtility";
import CtART from "./CustomTool/ResponsiveTable";

class ItemMaster extends Component {
  state = {
    Packing: [],
    Unit: [],
    HSNCode: [],
    TaxList: [],
    columnsdata: [
      { accessorKey: "vac_itemname", header: "Item Name" },
      { accessorKey: "vac_unit", header: "Unit" },
      { accessorKey: "vac_hsncode", header: "HSN Code" },
      { accessorKey: "dec_purchaserate", header: "Purchase Rate" },
      { accessorKey: "dec_salesrate", header: "Sales Rate" },
      { accessorKey: "vac_taxname", header: "Tax" },
      { accessorKey: "dec_cgst", header: "CGST" },
      { accessorKey: "dec_cgstamo", header: "CGST Amount", hide: "true" },
      { accessorKey: "dec_sgst", header: "SGST" },
      { accessorKey: "dec_sgstamo", header: "SGST Amount", hide: "true" },
      { accessorKey: "dec_igst", header: "IGST" },
      { accessorKey: "dec_igstamo", header: "IGST Amount", hide: "true" },
    ],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      //  { id: 'bint_srno', label: 'SR NO' },
      { id: "vac_itemname", label: "Item Name" },
      // { id: 'vac_LegderName', label: 'Brand Name' },
      { id: "vac_unit", label: "Unit" },
      //   { id: "vac_LegderType", label: "Packing" },
      { id: "vac_hsncode", label: "HSN Code" },
      { id: "dec_purchaserate", label: "Purchase Rate" },
      { id: "dec_salesrate", label: "Sales Rate" },
      { id: "vac_taxname", label: "Tax" },
      { id: "dec_cgst", label: "CGST" },
      { id: "dec_cgstamo", label: "CGST Amount", hide: "true" },
      { id: "dec_sgst", label: "SGST" },
      { id: "dec_sgstamo", label: "SGST Amount", hide: "true" },
      { id: "dec_igst", label: "IGST" },
      { id: "dec_igstamo", label: "IGST Amount", hide: "true" },
    ],
    OpenStockColumns: [
      // { id: "Action", label: "Search", name: "Search" },
      { id: "vac_storename", label: "Store Name" },
      {
        id: "dec_openingqty",
        label: "Opening Qty",
        type: "CtTxtAmt",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "dec_openingvaluation",
        label: "Opening Valuation",
        type: "CtTxtAmt",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
    ],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "ItemMaster:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "ItemMaster:",
        actionType: "AlertResponsive",
      },
    ],
    OpeStockactionList: [
      {
        name: "Delete",
        icon: <Delete />,
        link: "ItemMaster:",
        actionType: "AlertResponsive",
      },
    ],
    keyColumn: [
      "bint_acid", //0
      "vac_itemname", //1
      "vac_unit", //2
      "vac_hsncode", //3
      "dec_purchaserate", //4
      "dec_salesrate", //5
      "vac_taxname", //6
      "dec_cgst", //7
      "dec_cgstamo", //8
      "dec_sgst", //9
      "dec_sgstamo", //10
      "dec_igst", //11
      "dec_igstamo", //12
      "dec_openingqty", //13
      "dec_openingvaluation", //14
      "OpeningData", //15
    ],
    OpeStockKeyColumn: [
      "vac_storename",
      "dec_openingqty",
      "dec_openingvaluation",
    ],
    formData: {
      bint_srno: "",
      EditItemName: "",
      txtItemName: "",
      EditUnit: "",
      cmbUnit: "",
      cmbHSNCode: "",
      txtPurchaseRate: "",
      txtSalesRate: "",
      cmbTax: "",
      txtCGST: "",
      decCgstAmo: "",
      txtSGST: "",
      decSgstAmo: "",
      txtIGST: "",
      decIgstAmo: "",
      txtOpeningQty: "",
      txtOpeningValuation: "",
    },
    searchData: {
      vac_itemname: "",
      vac_unit: "",
      vac_hsncode: "",
      dec_purchaserate: "",
      dec_salesrate: "",
      vac_taxname: "",
      dec_cgst: "",
      dec_cgstamo: "",
      dec_sgst: "",
      dec_sgstamo: "",
      dec_igst: "",
      dec_igstamo: "",
    },
    OpeStockSearchData: {
      vac_storename: "",
      dec_openingqty: "",
      dec_openingvaluation: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,

    dataLoadStatus: true,
    ARD: null,

    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,

    StoreList: [],
    rowsStore: [],
    rowsCountStore: 0,
    rowsPerPageStore: 5,
    ValidUnit: [
      { FullName: "BAGS", shortName: "BAG" },
      { FullName: "BALE", shortName: "BAL" },
      { FullName: "BUNDLES", shortName: "BDL" },
      { FullName: "BUCKLES", shortName: "BKL" },
      { FullName: "BILLION OF UNITS", shortName: "BOU" },
      { FullName: "BOX", shortName: "BOX" },
      { FullName: "BOTTLES", shortName: "BTL" },
      { FullName: "BUNCHES", shortName: "BUN" },
      { FullName: "CANS", shortName: "CAN" },
      { FullName: "CUBIC METERS", shortName: "CBM" },
      { FullName: "CUBIC CENTIMETERS", shortName: "CCM" },
      { FullName: "CENTIMETERS", shortName: "CMS" },
      { FullName: "CARTONS", shortName: "CTN" },
      { FullName: "DOZENS", shortName: "DOZ" },
      { FullName: "DRUMS", shortName: "DRM" },
      { FullName: "GREAT GROSS", shortName: "GGK" },
      { FullName: "GRAMMES", shortName: "GMS" },
      { FullName: "GROSS", shortName: "GRS" },
      { FullName: "GROSS YARDS", shortName: "GYD" },
      { FullName: "KILOGRAMS", shortName: "KGS" },
      { FullName: "KILOLITRE", shortName: "KLR" },
      { FullName: "KILOMETRE", shortName: "KME" },
      { FullName: "LITRES", shortName: "LTR" },
      { FullName: "MILILITRE", shortName: "MLT" },
      { FullName: "METERS", shortName: "MTR" },
      { FullName: "METRIC TON", shortName: "MTS" },
      { FullName: "NUMBERS", shortName: "NOS" },
      { FullName: "OTHERS", shortName: "OTH" },
      { FullName: "PACKS", shortName: "PAC" },
      { FullName: "PIECES", shortName: "PCS" },
      { FullName: "PAIRS", shortName: "PRS" },
      { FullName: "QUINTAL", shortName: "QTL" },
      { FullName: "ROLLS", shortName: "ROL" },
      { FullName: "SETS", shortName: "SET" },
      { FullName: "SQUARE FEET", shortName: "SQF" },
      { FullName: "SQUARE METERS", shortName: "SQM" },
      { FullName: "SQUARE YARDS", shortName: "SQY" },
      { FullName: "TABLETS", shortName: "TBS" },
      { FullName: "TEN GROSS", shortName: "TGM" },
      { FullName: "THOUSANDS", shortName: "THD" },
      { FullName: "TONNES", shortName: "TON" },
      { FullName: "TUBES", shortName: "TUB" },
      { FullName: "US GALLONS", shortName: "UGS" },
      { FullName: "UNITS", shortName: "UNT" },
      { FullName: "YARDS", shortName: "YDS" },
    ],
    openValidUnitList: false,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account : Item Master");
    }
    this.props.setActiveMenu("ItemMaster");
    // this.ShortCut();
    this.setSearchColumns();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    // this.getInfo();
  }
  componentWillUnmount() {
    // this.removeShortCut();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbTax") {
          let txtCGST = "",
            txtSGST = "",
            txtIGST = "";
          this.state.TaxList.map((Tax) => {
            if (Tax.vac_taxname === this.state.formData.cmbTax) {
              txtCGST = Tax.dec_cgst;
              txtSGST = Tax.dec_sgst;
              txtIGST = Tax.dec_igst;
            }
          });
          this.setState({
            formData: { ...this.state.formData, txtCGST, txtSGST, txtIGST },
          });
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleChangeRowsPerPageStore = (rowsPerPageStore) => {
    this.setState({ rowsPerPageStore });
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "vac_itemname",
        label: "Item Name",
        value: this.state.searchData.vac_itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_unit",
        label: "Unit",
        items: this.state.Unit,
        value: this.state.searchData.vac_unit,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_hsncode",
        items: this.state.HSNCode,
        label: "HSN Code",
        value: this.state.searchData.vac_hsncode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_purchaserate",
        label: "Purchase Rate",
        value: this.state.searchData.dec_purchaserate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_salesrate",
        label: "Sales Rate",
        value: this.state.searchData.dec_salesrate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "140",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_taxname",
        items: this.state.TaxList,
        label: "Tax",
        value: this.state.searchData.vac_taxname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
        // colID: 'status',
      },
      {
        cType: "Lbl",
        id: "dec_cgst",
        label: "CGST",
        value: this.state.searchData.dec_cgst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "140",
        maxLength: "100",
      },
      { cType: "Lbl", id: "dec_cgstamo" },
      {
        cType: "Lbl",
        id: "dec_sgst",
        label: "SGST",
        value: this.state.searchData.dec_sgst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "140",
        maxLength: "100",
      },
      { cType: "Lbl", id: "dec_sgstamo" },
      {
        cType: "Lbl",
        id: "dec_igst",
        label: "IGST",
        value: this.state.searchData.dec_igst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "140",
        maxLength: "100",
      },
      { cType: "Lbl", id: "dec_igstamo" }
    );
    this.setState({ searchColumns });
  };

  // setSearchColumns = () => {
  //   let searchColumns = [];
  //   searchColumns.push(
  //     {
  //       cType: "Lbl",
  //       id: "vac_storename",
  //       label: "Store Name",
  //       value: this.state.OpeStockSearchData.vac_storename,
  //       handleOnChange: this.handleOnSearchInputChange,
  //       width: "140",
  //       maxLength: "100",
  //     },
  //     {
  //       cType: "Lbl",
  //       id: "dec_openingqty",
  //       label: "Opening Qty",
  //       value: this.state.OpeStockSearchData.dec_openingqty,
  //       handleOnChange: this.handleOnSearchInputChange,
  //       width: "140",
  //       maxLength: "100",
  //     },
  //     {
  //       cType: "Lbl",
  //       id: "dec_openingvaluation",
  //       label: "Opening Valuation",
  //       value: this.state.OpeStockSearchData.dec_openingvaluation,
  //       handleOnChange: this.handleOnSearchInputChange,
  //       width: "140",
  //       maxLength: "100",
  //     }
  //   );
  //   this.setState({ searchColumns }, () => {
  //     console.log(this.state.searchColumns);
  //   });
  // };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_itemname.length === 0 ||
            (row["vac_itemname"] &&
              row["vac_itemname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_itemname.toLowerCase()))) &&
          (this.state.searchData.vac_unit === "" ||
            (row["vac_unit"] &&
              row["vac_unit"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_unit.toLowerCase()))) &&
          (this.state.searchData.vac_hsncode === "" ||
            (row["vac_hsncode"] &&
              row["vac_hsncode"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_hsncode.toLowerCase()))) &&
          (this.state.searchData.dec_purchaserate.length === 0 ||
            (row["dec_purchaserate"] &&
              row["dec_purchaserate"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dec_purchaserate.toLowerCase()
                ))) &&
          (this.state.searchData.dec_salesrate.length === 0 ||
            (row["dec_salesrate"] &&
              row["dec_salesrate"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dec_salesrate.toLowerCase()
                ))) &&
          (this.state.searchData.vac_taxname === "" ||
            (row["vac_taxname"] &&
              row["vac_taxname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_taxname.toLowerCase()))) &&
          (this.state.searchData.dec_cgst.length === 0 ||
            (row["dec_cgst"] &&
              row["dec_cgst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_cgst.toLowerCase()))) &&
          (this.state.searchData.dec_sgst.length === 0 ||
            (row["dec_sgst"] &&
              row["dec_sgst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_sgst.toLowerCase()))) &&
          (this.state.searchData.dec_igst.length === 0 ||
            (row["dec_igst"] &&
              row["dec_igst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_igst.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnOpeStockSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.OpeStockSearchData.vac_storename.length === 0 ||
            (row["vac_storename"] &&
              row["vac_storename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.OpeStockSearchData.vac_storename.toLowerCase()
                ))) &&
          (this.state.OpeStockSearchData.dec_openingqty.length === 0 ||
            (row["dec_openingqty"] &&
              row["dec_openingqty"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.OpeStockSearchData.dec_openingqty.toLowerCase()
                ))) &&
          (this.state.OpeStockSearchData.dec_openingvaluation.length === 0 ||
            (row["dec_openingvaluation"] &&
              row["dec_openingvaluation"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.OpeStockSearchData.dec_openingvaluation.toLowerCase()
                )))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleARDonActionClick = (row) => {
    console.log("row", row);

    const bint_srno = row.bint_acid,
      EditItemName = row.vac_itemname,
      txtItemName = row.vac_itemname,
      EditUnit = row.vac_unit,
      cmbUnit = row.vac_unit,
      cmbHSNCode = row.vac_hsncode,
      txtPurchaseRate = row.dec_purchaserate,
      txtSalesRate = row.dec_salesrate,
      cmbTax = row.vac_taxname,
      txtCGST = row.dec_cgst,
      decCgstAmo = row.dec_cgstamo,
      txtSGST = row.dec_sgst,
      decSgstAmo = row.dec_sgstamo,
      txtIGST = row.dec_igst,
      decIgstAmo = row.dec_igstamo,
      txtOpeningQty = row.dec_openingqty,
      txtOpeningValuation = row.dec_openingvaluation,
      actionName = row.actionName;
    if (actionName === "Edit") {
      let tempStoreList = [];
      // console.log("tempStoreList Initial ", tempStoreList);
      this.state.StoreList.map((store) => {
        tempStoreList.push({
          int_default: store.int_default,
          vac_storename: store.vac_storename,
        });
      });
      // console.log("tempStoreList will be passed to function ", tempStoreList);
      let rowsStore = loadValuesIntoMainArray({
        MainArray: tempStoreList,
        MainArrayColList: ["vac_storename", "int_default"],
        // ValueArray: values[15].value,
        compareColID: "vac_storename",
        copyValueColIDArray: [
          { id: "dec_openingqty", datatype: "string" },
          { id: "dec_openingvaluation", datatype: "string" },
        ],
      });
      // console.log('rowsStore', rowsStore)
      // console.log('this.state.StoreList', this.state.StoreList)
      this.setState(
        {
          formData: {
            ...this.state.formData,
            bint_srno,
            EditItemName,
            txtItemName,
            EditUnit,
            cmbUnit,
            cmbHSNCode,
            txtPurchaseRate,
            txtSalesRate,
            cmbTax,
            txtCGST,
            decCgstAmo,
            txtSGST,
            decSgstAmo,
            txtIGST,
            decIgstAmo,
            txtOpeningQty,
            txtOpeningValuation,
          },
          rowsStore,
        },
        () => {
          // console.log("this.state.rowsStore", this.state.rowsStore);
        }
      );
      window.scrollTo(0, 0);
      document.getElementById("txtItemName").focus();
    } else if (actionName === "Delete") {
      this.DeleteData(EditItemName, EditUnit);
    } else {
      let rows = this.state.rows.filter((row) => {
        if (row.bint_srno !== bint_srno) return row;
      });
      const rowsCount = rows.length;
      this.setState({ rows, rowsCount });
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["vac_itemname", "vac_unit"]),
      EditItemName = row.vac_itemname,
      EditUnit = row.vac_unit;
    this.DeleteData(EditItemName, EditUnit);
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_acid",
      "vac_itemname",
      "vac_itemname",
      "vac_unit",
      "vac_unit",
      "vac_hsncode",
      "dec_purchaserate",
      "dec_salesrate",
      "vac_taxname",
      "dec_cgst",
      "dec_cgstamo",
      "dec_sgst",
      "dec_sgstamo",
      "dec_igst",
      "dec_igstamo",
      "dec_openingqty",
      "dec_openingvaluation",
    ]);
    const bint_srno = row.bint_acid,
      EditItemName = row.vac_itemname,
      txtItemName = row.vac_itemname,
      EditUnit = row.vac_unit,
      cmbUnit = row.vac_unit,
      cmbHSNCode = row.vac_hsncode,
      txtPurchaseRate = row.dec_purchaserate,
      txtSalesRate = row.dec_salesrate,
      cmbTax = row.vac_taxname,
      txtCGST = row.dec_cgst,
      decCgstAmo = row.dec_cgstamo,
      txtSGST = row.dec_sgst,
      decSgstAmo = row.dec_sgstamo,
      txtIGST = row.dec_igst,
      decIgstAmo = row.dec_igstamo,
      txtOpeningQty = row.dec_openingqty,
      txtOpeningValuation = row.dec_openingvaluation;

    let tempStoreList = [];
    // console.log("tempStoreList Initial ", tempStoreList);
    this.state.StoreList.map((store) => {
      tempStoreList.push({
        int_default: store.int_default,
        vac_storename: store.vac_storename,
      });
    });
    // console.log("tempStoreList will be passed to function ", tempStoreList);
    let rowsStore = loadValuesIntoMainArray({
      MainArray: tempStoreList,
      MainArrayColList: ["vac_storename", "int_default"],
      // ValueArray: values[15].value,
      compareColID: "vac_storename",
      copyValueColIDArray: [
        { id: "dec_openingqty", datatype: "string" },
        { id: "dec_openingvaluation", datatype: "string" },
      ],
    });
    // console.log('rowsStore', rowsStore)
    // console.log('this.state.StoreList', this.state.StoreList)
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          EditItemName,
          txtItemName,
          EditUnit,
          cmbUnit,
          cmbHSNCode,
          txtPurchaseRate,
          txtSalesRate,
          cmbTax,
          txtCGST,
          decCgstAmo,
          txtSGST,
          decSgstAmo,
          txtIGST,
          decIgstAmo,
          txtOpeningQty,
          txtOpeningValuation,
        },
        rowsStore,
      },
      () => {
        // console.log("this.state.rowsStore", this.state.rowsStore);
      }
    );
    window.scrollTo(0, 0);
    document.getElementById("txtItemName").focus();
  };

  handleOnRowDataChangeStore = (rowsStore, handledRowIndex, colID) => {
    this.setState({ rowsStore, rowsCountStore: rowsStore.length });
  };
  //#endregion handle

  //#region function
  // ShortCut = () => {
  //   this.removeShortCut = setKeyboardShortcuts(
  //     this.SaveItemMaster,
  //     this.clearInfo,
  //     () => {
  //       this.DeleteData(
  //         this.state.formData.EditItemName,
  //         this.state.formData.EditUnit
  //       );
  //     }
  //     // this.saveSales(true)
  //   );
  // };
  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      {
        handleOnclickSave: this.SaveItemMaster,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: () => {
          this.DeleteData(
            this.state.formData.EditItemName,
            this.state.formData.EditUnit
          );
        },
      }

      // this.saveSales(true)
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      numberKeysArray: ["txtPurchaseRate", "txtSalesRate"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateItemMaster = () => {
    let result = false;
    if (this.state.formData.txtItemName.length <= 0) {
      this.props.toastErrorMsg("Enter Item Name", "txtItemName");
    } else if (this.state.formData.cmbTax.length <= 0) {
      this.props.toastErrorMsg("Enter Tax", "cmbTax");
    } else if (this.validateTax() === false) {
      this.props.toastErrorMsg("Select valid Tax", "cmbTax");
    } else {
      result = true;
    }
    return result;
  };

  validateTax = () => {
    let result = false;
    if (this.state.formData.cmbTax.length > 0) {
      this.state.TaxList.map((row) => {
        if (row.vac_taxname === this.state.formData.cmbTax) {
          result = true;
        }
      });
    }
    return result;
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "ItemList",
        bint_acid: localStorage.getItem("acid"),
        bolLoadTaxData: true,
        bolLoadStoreList: true,
        bolLoadOpeningData: true,
        bolLoadHSNCodeList: true,
        bolLoadUnitList: true,
      };
      fetchItemMaster(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0,
            rowsStore = [], //[],
            rowsCountStore = 0,
            TaxList = [],
            StoreList = [], //[],
            Unit = [],
            HSNCode = [];

          if (res.data.ItemList && res.data.ItemList.length > 0) {
            rows = res.data.ItemList;
            rowsCount = rows.length;
          }
          if (res.data.StoreList && res.data.StoreList.length > 0) {
            rowsStore = res.data.StoreList;
            rowsCountStore = rowsStore.length;
          }
          if (res.data.TaxList && res.data.TaxList.length > 0) {
            TaxList = res.data.TaxList;
          }
          if (res.data.StoreList && res.data.StoreList.length > 0) {
            StoreList = res.data.StoreList;
          }
          if (res.data.UnitList && res.data.UnitList.length > 0) {
            Unit = res.data.UnitList;
          }
          if (res.data.HSNCodeList && res.data.HSNCodeList.length > 0) {
            HSNCode = res.data.HSNCodeList;
          }
          this.setState(
            {
              dataLoadStatus,
              rows,
              rowsCount,
              rowsStore,
              rowsCountStore,
              TaxList,
              StoreList,
              Unit,
              HSNCode,
            },
            () => {
              // console.log("this.state.rowsStore", this.state.rowsStore);
              if (this.props.refreshItemNameList) {
                this.props.refreshItemNameList(rows);
              }
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in getInfo.", error);
        });
    });
    document.getElementById("txtItemName").focus();
  };

  clearInfo = () => {
    const txtItemName = "",
      txtBrandName = "",
      cmbUnit = "",
      cmbHSNCode = "",
      txtPurchaseRate = "",
      txtSalesRate = "",
      cmbTax = "",
      txtCGST = "",
      txtSGST = "",
      txtIGST = "",
      txtOpeningQty = "",
      txtOpeningValuation = "",
      EditItemName = "",
      EditUnit = "",
      rowsStore = copyArrayValue(this.state.StoreList);

    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtItemName,
          txtBrandName,
          cmbUnit,
          cmbHSNCode,
          txtPurchaseRate,
          txtSalesRate,
          cmbTax,
          txtCGST,
          txtSGST,
          txtIGST,
          txtOpeningQty,
          txtOpeningValuation,
          EditItemName,
          EditUnit,
        },
        rowsStore,
        rowsCountStore: rowsStore.length,
      },
      () => {
        document.getElementById("txtItemName").focus();
      }
    );
  };

  SaveItemMaster = () => {
    if (this.validateItemMaster()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveItem",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_itemname: this.state.formData.txtItemName,
          vac_unit: this.state.formData.cmbUnit,
          vac_hsncode: this.state.formData.cmbHSNCode,
          dec_purchaserate: Number(this.state.formData.txtPurchaseRate),
          dec_salesrate: Number(this.state.formData.txtSalesRate),
          vac_taxname: this.state.formData.cmbTax,
          dec_cgst: Number(this.state.formData.txtCGST),
          dec_cgstamo: 0,
          dec_sgst: Number(this.state.formData.txtSGST),
          dec_sgstamo: 0,
          dec_igst: Number(this.state.formData.txtIGST),
          dec_igstamo: 0,
          // dec_openingqty: Number(this.state.formData.txtOpeningQty),
          // dec_openingvaluation: Number(this.state.formData.txtOpeningValuation),
          edit_itemname: this.state.formData.EditItemName,
          edit_unit: this.state.formData.EditUnit,
          OpeningData: getRowsWithColsExists({
            dataArray: applyTrimOnArray(this.state.rowsStore),
            colList: ["dec_openingqty"], //, "dec_openingvaluation"],
            excludeBlankColValue: false,
          }) /* [{
            vac_storename:'',
            dec_openingqty:0,
            dec_openingvaluation:''
          }] */,
        };
        fetchItemMaster(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.getInfo();
              this.clearInfo(true);
            } else {
              this.setState({
                dataLoadStatus: true,
              });
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in SaveLedgerDetail.", error);
          });
      });
    }
  };

  DeleteData = (EditItemName, EditUnit) => {
    if (EditItemName.length > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Item : " +
              EditItemName +
              " and Unit : " +
              EditUnit +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteItemMaster(EditItemName, EditUnit);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteItemMaster = (txtItemName, cmbUnit) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteItem",
        bint_acid: localStorage.getItem("acid"),
        vac_itemname: txtItemName,
        vac_unit: cmbUnit,
      };
      fetchItemMaster(reqData)
        .then((res) => {
          // console.log("redata", res.data);
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState({ ARD: null }, () => {
              this.getInfo();
              this.clearInfo(true);
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in delete DeleteItemMaster. " + error
          );
        });
    });
    return false;
  };

  handleOpenValidUnit = () => {
    this.setState({
      openValidUnitList: true,
    });
  };

  handleCloseValidUnit = () => {
    this.setState({
      openValidUnitList: false,
    });
  };

  // //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    let isDisplayBtn =
      this.props.OpenFromSalesItem && this.props.OpenFromSalesItem == "Yes"
        ? true
        : false;

    let validPackingList = (
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <thead>
          <tr
            style={{
              backgroundColor: "#f2f2f2",
              borderBottom: "2px solid #000",
            }}
          >
            <th
              style={{
                border: "1px solid #000",
                padding: "8px",
                textAlign: "left",
              }}
            >
              Unit
            </th>
            <th
              style={{
                border: "1px solid #000",
                padding: "8px",
                textAlign: "left",
              }}
            >
              Valid Short Unit
            </th>
          </tr>
        </thead>
        <tbody>
          {this.state.ValidUnit.map((row, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                {row.FullName}
              </td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                {row.shortName}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>Item Master</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item xs={10} sm={12}>
                <CtMultiLineText
                  id="txtItemName"
                  label="Item Name*"
                  value={this.state.formData.txtItemName}
                  handleOnChange={this.handleOnChange}
                  // width={540}
                  width={"100%"}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbUnit"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbUnit"
                  label="Unit"
                  items={this.state.Unit}
                  value={this.state.formData.cmbUnit}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPurchaseRate"
                  colID="vac_unit"
                />
              </Grid>
              <Grid item marginTop={1}>
                <Button
                  variant="outlined"
                  startIcon={<Info />}
                  onClick={this.handleOpenValidUnit}
                >
                  Valid E-way bill Unit List
                </Button>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtNum
                  id="txtPurchaseRate"
                  value={this.state.formData.txtPurchaseRate}
                  label="Purchase Rate"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtSalesRate"
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtSalesRate"
                  label="Sales Rate"
                  // disabled={true}
                  value={this.state.formData.txtSalesRate}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbTax"
                />
              </Grid>

              <Grid item>
                <CtCmb
                  id="cmbTax"
                  label="Tax*"
                  items={this.state.TaxList}
                  value={this.state.formData.cmbTax}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={20}
                  colID="vac_taxname"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbHSNCode"
                />
              </Grid>

              <Grid item>
                <CtCmbEditable
                  id="cmbHSNCode"
                  value={this.state.formData.cmbHSNCode}
                  items={this.state.HSNCode}
                  label="HSN Code"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtCGST"
                  colID="vac_hsncode"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtCGST"
                  label="CGST"
                  disabled={true}
                  value={this.state.formData.txtCGST}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtSGST"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtSGST"
                  label="SGST"
                  disabled={true}
                  value={this.state.formData.txtSGST}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtIGST"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtIGST"
                  label="IGST"
                  disabled={true}
                  value={this.state.formData.txtIGST}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>
            </Grid>
            {isDisplayBtn == false ? (
              <>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={2}
                  marginTop={0}
                >
                  <Grid item>
                    <CtBtn
                      label="Save"
                      onClick={() => {
                        this.trimFormData(() => {
                          this.SaveItemMaster();
                        });
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <CtBtn
                      label="New"
                      onClick={this.clearInfo}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <CtBtn
                      label="Delete"
                      onClick={() => {
                        this.DeleteData(
                          this.state.formData.EditItemName,
                          this.state.formData.EditUnit
                        );
                      }}
                    />
                  </Grid>
                </Grid>
              </>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs="12" md="auto">
            <TableList
              columns={this.state.OpenStockColumns}
              counter={this.state.counter}
              rows={this.state.rowsStore}
              rowsCount={this.state.rowsCountStore}
              rowsPerPage={this.state.rowsPerPageStore}
              handleChangeRowsPerPage={this.handleChangeRowsPerPageStore}
              keyColumn={this.state.OpeStockKeyColumn}
              handleOnRowDataChange={this.handleOnRowDataChangeStore}
            />
          </Grid>
          {isDisplayBtn == true ? (
            <>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  <CtBtn
                    label="Save"
                    onClick={() => {
                      this.trimFormData(() => {
                        this.SaveItemMaster();
                      });
                    }}
                  />
                </Grid>
                <Grid item>
                  <CtBtn label="New" onClick={this.clearInfo} />
                </Grid>
                <Grid item>
                  <CtBtn
                    label="Delete"
                    onClick={() => {
                      this.DeleteData(
                        this.state.formData.EditItemName,
                        this.state.formData.EditUnit
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            ""
          )}
        </Grid>
        <br />
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry='New Product Entry'
        /> */}
        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("Customer")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          // tableButtonAction={[
          //   {
          //     label: "Sales Entry",
          //     onClick: this.handleOnNewEntryClick,
          //     addPluseIcon: true,
          //   },
          //   // this.props.userPrivilege["Entry:Proposal"] != "R"
          //   //   ? {
          //   //       label: "Add New Proposal",
          //   //       onClick: this.handleOnNewEntryClick,
          //   //       addPluseIcon: true,
          //   //     }
          //   //   : "",
          // ]}
          showColumnFilters={false}
          actionColSize={90}
          hideColIdList={["dec_cgstamo", "dec_sgstamo", "dec_igstamo"]}
          density={"compact"}
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
        <Grid item>
          <Dialog
            open={this.state.openValidUnitList}
            onClose={this.handleCloseValidUnit}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Valid E-Way Bill Unit List"}
            </DialogTitle>
            <DialogContent>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "12px",
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                Note: Use only the "Valid Short Unit" listed below for each
                Sales Item's Packing Unit.
              </Typography>
              <DialogContentText id="alert-dialog-description">
                {validPackingList}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseValidUnit}>Ok</Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(ItemMaster)));
